import { motion } from 'framer-motion';
import klemensImg from '@/assets/team/klemens.png.asset.json';
import leanderImg from '@/assets/team/leander.png.asset.json';
import tomImg from '@/assets/team/tom.jpg.asset.json';
import maxImg from '@/assets/team/max.png.asset.json';
import rahmanImg from '@/assets/team/rahman.jpg.asset.json';
import paulImg from '@/assets/team/paul.jpg.asset.json';

const testimonials = [
  {
    quote:
      'Ich bin bei Hauptstadt Consulting Partners, weil ich hier weit mehr als nur beraten darf und den Standort von Anfang an aktiv mitgestalte, das macht für mich den entscheidenden Unterschied.',
    name: 'Klemens von Rosen',
    role: 'Seniorpartner',
    image: klemensImg.url,
    url: 'https://www.horbach.de/klemens-von-rosen.html',
  },
  {
    quote:
      'Ich wollte selbstständig arbeiten ohne dabei allein zu sein, und genau diese Kombination aus Freiheit und Rückenwind habe ich hier gefunden.',
    name: 'Adrian Leander Heiß',
    role: 'Partner',
    image: leanderImg.url,
    url: 'https://www.horbach.de/adrian-leander-heiss.html',
  },
  {
    quote:
      'Als Quereinsteiger habe ich dank der strukturierten Einarbeitung schon nach wenigen Monaten meine ersten Mandate eigenständig betreut.',
    name: 'Tom Hofmann',
    role: 'Seniorberater',
    image: tomImg.url,
    url: 'https://www.horbach.de/tom-hofmann.html',
  },
  {
    quote:
      'Überzeugt hat mich am Ende die reine Fachlichkeit unserer Beratung, ganz ohne Vertriebsdruck oder vorgefertigte Skripte.',
    name: 'Maximilian Baiker',
    role: 'Seniorberater',
    image: maxImg.url,
    url: 'https://www.horbach.de/maximilian-baiker.html',
  },
  {
    quote:
      'Der Zusammenhalt im Team ist für mich das Besondere, weil wir uns gegenseitig weiterbringen und wirklich füreinander da sind.',
    name: 'Rahman Yacoubi',
    role: 'Seniorberater',
    image: rahmanImg.url,
    url: 'https://de.linkedin.com/in/rahman-yaqoubi-15822b282',
  },
  {
    quote:
      'Mich begeistert, dass ich meine Mandanten über Jahre begleiten kann und dabei immer die Freiheit habe, meinen eigenen Weg zu gehen.',
    name: 'Paul Lucas Blumentritt',
    role: 'Seniorberater',
    image: paulImg.url,
    url: 'https://www.horbach.de/paul-lucas-blumentritt.html',
  },
];

const TeamSection = () => {
  return (
    <section id="team" className="section-warm py-20 md:py-28">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mb-14">
          <p className="text-[11px] uppercase tracking-[0.22em] text-primary-dark font-semibold mb-4">Das Team</p>
          <h2 className="font-normal text-foreground mb-6">
            Menschen, die schon <span className="italic text-primary-dark">Ja gesagt haben.</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Über 20 Berater aus sehr unterschiedlichen Hintergründen bauen Berlin gemeinsam auf und teilen alle den Anspruch einer Beratung die wirklich trägt.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="premium-card p-8"
            >
              <blockquote className="font-serif text-xl md:text-2xl text-foreground leading-snug mb-6">
                „{t.quote}"
              </blockquote>
              <figcaption className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-primary/10 flex-shrink-0">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <a
                    href={t.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-foreground hover:text-primary-dark transition-colors"
                  >
                    {t.name}
                  </a>
                  <div className="text-xs text-muted-foreground">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
